export const filterSectionsByTitle = (items) => {
	const wanted = [
		'Articles',
		'EBooks',
		'Patents',
		'GALE Resources',
		'Aquino AI',
		'Job Hunter',
		'Interesting Links',
		'Tutorials',
		'Career Development',
		'News',
	];
	return items.filter((item) => wanted.includes(item.title));
};
